import { useState, useEffect } from "react";
import { useSelector } from 'react-redux';
import { useUser } from "../Auth/AuthContext";
import {
    FormLabel, Grid, InputAdornment, TextField
} from '@mui/material';

import SearchIcon from '@mui/icons-material/Search';
import FormAutocomplete from '../Form/FormAutocomplete';
import SystemIcons from '../Shared/SystemIcons';
import ControlPanelFilters from './ControlPanelFilters';
import Subtitle from '../Shared/Subtitle';

const cssControlPanel = { border: '1px solid #ccc', borderRadius: 1, p: 1, mb: 1 }

const ControlPanel = props => {
    const user = useUser();
    const [filter, setFilter] = useState({})
    const sysconfig = useSelector(state => state.sysconfig);
    const options = sysconfig?.data?.map(sys => ({
        value: sys.SystemKey,
        system: sys.SystemKey,
        label: sys.Name
    })) || []

    const handleFilter = e => {
        const val = e.target.name === "systems" ? [
            ...(filter?.systems || []),
            ...e.target.value
        ] : e.target.value
        const newFilter = { ...filter, [e.target.name]: e.target.value }
        setFilter(newFilter)
        if (e.target.name !== 'search') {
            props.handler(newFilter)
        }
    }

    const data = useSelector(state => (state[props.page.toLowerCase()] || {}).value)

    useEffect(() => {
        setFilter(data === null ? {} : filter)
    }, [data])

    useEffect(() => {
        const timeOutId = setTimeout(() => {
            props.handler({ ...filter, search: filter.search })
        }, 500);
        return () => clearTimeout(timeOutId);
    }, [filter.search]);

    return <Grid item xs={12}>
        <Grid container sx={cssControlPanel}>
            <Grid item xs={12}>
                <Grid container >
                    {/* Search */}
                    <FormLabel>Search</FormLabel>
                    <Grid item xs={12} className="ControlPanelItem">
                        <TextField
                            fullWidth
                            variant="standard"
                            type="search"
                            name="search"
                            value={filter.search || ''}
                            onChange={handleFilter}
                            autoComplete='off'
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <SearchIcon />
                                    </InputAdornment>
                                ),
                            }}
                        />
                    </Grid>
                </Grid>
                {!props.hideSystems &&
                    <Grid container>
                        <FormLabel>Systems</FormLabel>
                        <FormAutocomplete
                            multiple
                            name="systems"
                            options={options}
                            value={filter?.systems || ''}
                            handler={handleFilter}
                        />
                    </Grid>
                }

                {/* Filters */}
                <Grid container >
                    <ControlPanelFilters
                        page={props.page}
                        filter={filter}
                        handler={handleFilter}
                        selects={props.selects}
                        reset={data === null}
                    />
                </Grid>
            </Grid>
        </Grid>
    </Grid >
}

export default ControlPanel;